<template>
  <div>
    <nav>
      <div class="nav__logo">
        <a href="#"><img src="https://storage-alikar.b-cdn.net/aiphotos/133/1699571542080596.png" class="img_logo" alt="logo" /></a>
      </div>
      <ul class="nav__links">
        <li class="link"><a href="#header_content">Accueil</a></li>
        <li class="link"><a href="#explore_header">Service</a></li>
        <li class="link"><a href="#about">About</a></li>
        <li class="link"><a href="#price_container">Tarification</a></li>
      </ul>
      <button class="btn"><a style="color: white;" href="https://gestionfitnesshero.com/staff/login">Login</a></button>
    </nav>

    <header id="header_content" class="section__container header__container">
      <div class="header__content">
        <span class="bg__blur"></span>
        <span class="bg__blur header__blur"></span>
        <h4>Gestion Fitnnes Hero</h4>
        <h1><span>Simplifiez</span> la gestion de votre salle de sport</h1>
        <p>
            GestionSport est la solution en ligne pour faciliter l'inscription des membres, la gestion des abonnements et le suivi des présences dans votre salle de sport.
        </p>
        <button class="btn"><a style="color: white;" href="https://gestionfitnesshero.com/staff/login">Get Started</a></button>
      </div>
      
    </header>

    <section id="explore_header" class="section__container explore__container">
      <div class="explore__header">
        <h2 class="section__header">Notre Service</h2>
        <div class="explore__nav">
          <span><i class="ri-arrow-left-line"></i></span>
          <span><i class="ri-arrow-right-line"></i></span>
        </div>
      </div>
      <div class="explore__grid">
        <div class="explore__card">
          <span><i class="ri-boxing-fill"></i></span>
          <h4>Gestion simplifiée des membres</h4>
          <p>
            Avec Gestionfitnesshero, vous pouvez facilement gérer l'inscription de vos membres, suivre leurs abonnements et gérer les présences lors des séances. Notre solution intuitive vous permet de gagner du temps et d'optimiser la gestion de votre salle de sport.
          </p>
        </div>
        <div class="explore__card">
          <span><i class="ri-heart-pulse-fill"></i></span>
          <h4>Suivi des abonnements en temps réel</h4>
          <p>
            Grâce à Gestionfitnesshero, vous pouvez suivre les abonnements de vos membres en temps réel. Vous serez informé des échéances et pourrez facilement gérer les renouvellements.
          </p>
        </div>
        <div class="explore__card">
          <span><i class="ri-run-line"></i></span>
          <h4>Contrôle précis des présences</h4>
          <p>
            Avec Gestionfitnesshero, vous pouvez facilement enregistrer les présences de vos membres lors des séances. Vous aurez une vue d'ensemble sur l'affluence et pourrez prendre des mesures pour optimiser l'organisation de vos cours.
          </p>
        </div>
      
      </div>
    </section>

    <section class="section__container class__container">
      <div class="class__image">
        <span class="bg__blur"></span>
        <img src="../../assets/img/class-1.jpg" alt="class" class="class__img-1" />
        <img src="../../assets/img/class-2.jpg" alt="class" class="class__img-2" />
      </div>
      <div class="class__content">
        <h2 class="section__header">Une Gestion Simplifiée Des Salles de Sport</h2>
        <p>
            GestionSport est la solution en ligne pour faciliter l'inscription des membres, la gestion des abonnements et le suivi des présences dans votre salle de sport.
        </p>
        <!-- <button class="btn">Book A Class</button> -->
      </div>
    </section>

    <section id="about" class="section__container join__container">
      <h2 class="section__header">Gérez vos membres en toute simplicité</h2>
      <p class="section__subheader">
        Avec GestionSport, vous pouvez facilement gérer l'inscription de vos membres, suivre leurs abonnements et gérer les présences lors des séances. Notre solution intuitive vous permet de gagner du temps et d'optimiser la gestion de votre salle de sport.
      </p>
      <div class="join__image">
        <img src="../../assets/img/img-sport.jpeg" alt="Join" />
        <div class="join__grid">
          <div class="join__card">
            <span><i class="ri-user-star-fill"></i></span>
            <div class="join__card__content">
              <h4>Suivez les abonnements de vos membres              </h4>
              <p>Grâce à GestionSport, vous pouvez suivre les abonnements de vos membres en temps réel. Vous serez informé des échéances et pourrez facilement gérer les renouvellements.</p>
            </div>
          </div>
          <div class="join__card">
            <span><i class="ri-vidicon-fill"></i></span>
            <div class="join__card__content">
              <h4>Contrôlez les présences lors des séances</h4>
              <p>Avec GestionSport, vous pouvez facilement enregistrer les présences de vos membres lors des séances. Offrez à vos membres une expérience de qualité en assurant un suivi précis de leur participation.</p>
            </div>
          </div>.
    
        </div>
      </div>
    </section>

    <section id="price_container" class="section__container price__container">
      <h2 class="section__header">Tarification simple pour commencer      </h2>
      <p class="section__subheader">Choisissez votre formule et commencez votre essai gratuit de 30 jours </p>
      <div class="price__grid">
        <div class="price__card">
          <div class="price__card__content">
            <h4>Pack 6 mois</h4>
            <h3>1800 DH</h3>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              Domaine connecté
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              Temps de réponse du support dédié
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              essai gratuit de 30 jours
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              server Hosting
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              1 Salle de sport incluse
            </p>
          </div>
          <button class="btn price__btn"><a style="color: white;" href="https://gestionfitnesshero.com/staff/login">Get Started</a></button>
        </div>
        <div class="price__card">
          <div class="price__card__content">
            <h4>Pack 12 mois</h4>
            <h3>2500 DH</h3>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              Domaine connecté
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              Temps de réponse du support dédié
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              essai gratuit de 30 jours
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              server Hosting
            </p>
            <p>
              <i class="ri-checkbox-circle-line"></i>
              1 Salle de sport incluse
            </p>
          </div>
          <button class="btn price__btn"><a style="color: white;" href="https://gestionfitnesshero.com/staff/login">Get Started</a></button>
        </div>
      </div>
    </section>

    <section class="review">
      <div class="section__container review__container">
        <span><i class="ri-double-quotes-r"></i></span>
        <div class="review__content">
          <h4>AVIS DES MEMBRES</h4>
          <div class="">
            <p>
              Gestion Fitnnes Hero a révolutionné la gestion de ma salle de sport.
            </p>
            <p>
              Gestion Fitnnes Hero simplifie réellement le processus d'inscription des membres
            </p>
            <p>
              La capacité de gérer les abonnements en ligne peut être un gain de temps considérable pour les propriétaires de salles de sport
            </p>
         
          </div>
          <div class="review__rating">
            <span><i class="ri-star-fill"></i></span>
            <span><i class="ri-star-fill"></i></span>
            <span><i class="ri-star-fill"></i></span>
            <span><i class="ri-star-fill"></i></span>
            <span><i class="ri-star-half-fill"></i></span>
          </div>
       
        </div>
      </div>
    </section>

    <footer class="section__container footer__container">
      <span class="bg__blur"></span>
      <span class="bg__blur footer__blur"></span>
      <div class="footer__col">
        <div class="footer__logo"><img src="https://storage-alikar.b-cdn.net/aiphotos/133/1699571542080596.png" class="img_logo" alt="logo" /></div>
        <p>
          GestionSport est la solution en ligne pour faciliter l'inscription des membres, la gestion des abonnements et le suivi des présences dans votre salle de sport.
        </p>
        <div class="footer__socials">
          <a href="https://www.linkedin.com/in/othman-bouranja-055a68208/"><i class="fa-brands fa-linkedin"></i></a>
          <a href="https://github.com/OthmanBouranja"><i class="fa-brands fa-github"></i></a>
          <a href="https://twitter.com/BouranjaO"><i class="ri-twitter-fill"></i></a>
          <a href="https://bouranja.com/"><i class="fa-solid fa-globe"></i></a>
        </div>
      </div>
      <div class="footer__col">
        <h4>Services</h4>
        <a href="#">Inscription des membres</a>
        <a href="#">Suivi des abonnements</a>
        <a href="#">Contrôle des présences</a>
      </div>
      <div class="footer__col">
        <h4>Contact</h4>
        <a href="#"> <i class="fa-solid fa-phone"></i> 06 55 70 55 97</a>
        <a href="#" style="display: flex;align-items: center;"><i style="margin-right: 6px;" class="fa-solid fa-envelope"></i> bouranjaothmane@gmail.com</a>
        <a href="https://bouranja.com/"><i style="margin-right: 6px;" class="fa-solid fa-globe"></i>Bouranja.com</a>

     
      </div>
    </footer>


    <div class="footer__bar">
      Copyright © 2024 <a class="" style="color: white;text-decoration: underline;" href="https://bouranja.com/">Bouranja</a> All rights reserved.
    </div>
  </div>
</template>
  
<style >
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap");

:root {
  --primary-color: #111317;
  --primary-color-light: #1f2125;
  --primary-color-extra-light: #35373b;
  --secondary-color: #f9ac54;
  --secondary-color-dark: #d79447;
  --text-light: #d1d5db;
  --white: #ffffff;
  --max-width: 1200px;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html {
    scroll-behavior: smooth
}

.section__container {
  max-width: var(--max-width);
  margin: auto;
  padding: 2rem 1rem;
}

.section__header {
  margin-bottom: 1rem;
  font-size: 2.25rem;
  font-weight: 600;
  text-align: center;
  color: var(--white);
}

.section__subheader {
  /* max-width: 600px; */
  margin: auto;
  text-align: center;
  color: var(--text-light);
  font-size: 20px;
}

.btn {
  padding: 1rem 2rem;
  outline: none;
  border: none;
  font-size: 1rem;
  color: var(--white);
  background-color: var(--secondary-color);
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

.btn:hover {
  background-color: var(--secondary-color-dark);
}

img {
  width: 100%;
  display: flex;
}
.img_logo{
    width: 80px;
    border-radius: 22px;
}
a {
  text-decoration: none;
}

.bg__blur {
  position: absolute;
  box-shadow: 0 0 1000px 50px var(--secondary-color);
  z-index: -1;
}

body {
  font-family: "Poppins", sans-serif;
  background-color: var(--primary-color);
}

nav {
  max-width: var(--max-width);
  margin: auto;
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.nav__logo {
  max-width: 150px;
}

.nav__links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: 3rem;
}

.link a {
  position: relative;
  padding-bottom: 0.75rem;
  color: var(--white);
}

.link a::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 0;
  left: 0;
  bottom: 0;
  background-color: var(--secondary-color);
  transition: 0.3s;
}

.link a:hover::after {
  width: 50%;
}
.price__container{
  margin-top: 40px;
}

.header__container {
  position: relative;
  padding-top: 2rem;
  /* display: grid; */
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 2rem;
}

.header__container::before {
  content: "FITNESS";
  position: absolute;
  bottom: 5rem;
  right: 20rem;
  font-size: 10rem;
  font-weight: 700;
  line-height: 7rem;
  color: var(--white);
  opacity: 0.05;
  z-index: -1;
}
.header__content p{
    font-size: 25px;
}

.header__blur {
  bottom: 5rem;
  right: 0;
}

.header__content h4 {
  margin-bottom: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--secondary-color);
}

.header__content h1 {
  margin-bottom: 1rem;
  font-size: 5rem;
  font-weight: 700;
  line-height: 6rem;
  color: var(--white);
}

.header__content h1 span {
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke: 1px var(--white);
}

.header__content p {
  margin-bottom: 2rem;
  color: var(--text-light);
}

.header__image {
  position: relative;
}

.header__image::before {
  content: "o";
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 40rem;
  font-weight: 400;
  line-height: 20rem;
  color: var(--secondary-color);
  opacity: 0.1;
  z-index: -1;
}

.header__image img {
  max-width: 350px;
  margin: auto;
}

.explore__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.explore__nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.explore__nav span {
  padding: 0 6px;
  font-size: 1.5rem;
  color: var(--white);
  border: 2px solid var(--white);
  border-radius: 100%;
  cursor: pointer;
  transition: 0.3s;
}

.explore__nav span:hover {
  color: var(--secondary-color);
  border-color: var(--secondary-color);
}

.explore__grid {
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.explore__card {
  padding: 1rem;
  background-color: var(--primary-color-light);
  border: 2px solid transparent;
  border-radius: 10px;
  transition: 0.3s;
}

.explore__card:hover {
  background-color: var(--primary-color-extra-light);
  border-color: var(--secondary-color);
}

.explore__card span {
  display: inline-block;
  padding: 2px 9px;
  margin-bottom: 1rem;
  font-size: 1.75rem;
  color: var(--white);
  background-color: var(--secondary-color-dark);
  border-radius: 5px;
}

.explore__card h4 {
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--white);
}

.explore__card p {
  margin-bottom: 1rem;
  color: var(--text-light);
}

.explore__card a {
  color: var(--white);
  transition: 0.3s;
}

.explore__card a:hover {
  color: var(--secondary-color);
}

.class__container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.class__image {
  position: relative;
}

.class__image .class__img-1 {
  position: absolute;
  right: 0;
  top: 0;
  max-width: 500px;
  border-radius: 10px;
}

.class__image .class__img-2 {
  position: absolute;
  left: 0;
  bottom: 0;
  max-width: 300px;
  border-radius: 10px;
}

.class__content {
  padding: 2rem 0;
}

.class__content .section__header {
  text-align: left;
  max-width: 400px;
}

.class__content p {
  margin-bottom: 4rem;
  color: var(--text-light);
}

.join__image {
  margin-top: 4rem;
  position: relative;
}

.join__image img {
  border-radius: 10px;
}

.join__grid {
  position: absolute;
  bottom: -5rem;
  width: calc(100% - 4rem);
  padding: 2rem;
  margin: 0 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  background-color: var(--primary-color-light);
  border-radius: 10px;
}

.join__card {
  flex: 1 1 250px;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.join__card span {
  padding: 5px 12px;
  font-size: 1.75rem;
  color: var(--white);
  background-color: var(--secondary-color-dark);
  border-radius: 5px;
}

.join__card h4 {
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--white);
}

.join__card p {
  color: var(--text-light);
}

.price__grid {
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.price__card {
  padding: 3rem 2rem;
  display: flex;
  flex-direction: column;
  background-color: var(--primary-color-light);
  border: 2px solid transparent;
  border-radius: 10px;
  transition: 0.3s;
}

.price__card:hover {
  background-color: var(--primary-color-extra-light);
  border-color: var(--secondary-color);
}

.price__card__content {
  flex: 1;
  margin-bottom: 2rem;
}

.price__card h4 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--white);
}

.price__card h3 {
  padding-bottom: 1rem;
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 600;
  color: var(--white);
  border-bottom: 2px solid var(--white);
}

.price__card p {
  margin-bottom: 0.75rem;
  color: var(--white);
}

.price__card p i {
  margin-right: 0.5rem;
  font-size: 1.2rem;
  color: var(--secondary-color);
}

.price__btn {
  color: var(--secondary-color);
  background-color: transparent;
  border: 2px solid var(--secondary-color);
}

.price__btn:hover {
  color: var(--white);
  background-color: var(--secondary-color);
}

.review {
  background-color: var(--primary-color-light);
}

.review__container {
  display: flex;
  gap: 2rem;
}

.review__container > span {
  font-size: 6rem;
  color: var(--secondary-color);
  opacity: 0.5;
}

.review__content {
  flex: 1;
}

.review__content h4 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--white);
}

.review__content p {
  max-width: 800px;
  margin-bottom: 13px;
  color: var(--text-light);
}

.review__rating span {
  font-size: 1.5rem;
  color: var(--secondary-color);
}

.review__footer {
  margin-top: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.review__member {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.review__member img {
  max-width: 60px;
  border-radius: 100%;
}

.review__member__details h4 {
  margin-bottom: 0;
}

.review__nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.review__nav span {
  font-size: 2rem;
  color: var(--secondary-color);
  cursor: pointer;
}

.footer__container {
  position: relative;
  display: grid;
  grid-template-columns: 400px repeat(3, 1fr);
  gap: 2rem;
}

.footer__blur {
  bottom: 0;
  right: 0;
}

.footer__logo {
  max-width: 150px;
  margin-bottom: 2rem;
}

.footer__col p {
  margin-bottom: 2rem;
  color: var(--text-light);
}

.footer__socials {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.footer__socials a {
  padding: 5px 10px;
  font-size: 1.25rem;
  color: var(--secondary-color);
  border: 1px solid var(--secondary-color);
  border-radius: 100%;
  transition: 0.3s;
}

.footer__socials a:hover {
  color: var(--white);
  background-color: var(--secondary-color);
}

.footer__col h4 {
  margin-bottom: 2rem;
  font-size: 1.2rem;
  font-weight: 500;
  color: var(--white);
}

.footer__col > a {
  display: block;
  margin-bottom: 1rem;
  color: var(--text-light);
  transition: 0.3s;
}

.footer__col > a:hover {
  color: var(--secondary-color);
}

.footer__bar {
  max-width: var(--max-width);
  margin: auto;
  padding: 1rem;
  font-size: 0.8rem;
  color: var(--white);
}

@media (width < 900px) {
  .nav__links {
    display: none;
  }

  .header__container {
    grid-template-columns: repeat(1, 1fr);
  }

  .header__image {
    grid-area: 1/1/2/2;
  }

  .explore__grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .class__container {
    grid-template-columns: repeat(1, 1fr);
  }

  .class__image {
    min-height: 500px;
  }

  .price__grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .review__container {
    gap: 2rem;
  }

  .footer__container {
    grid-template-columns: 1fr 200px;
  }
}

@media (width < 600px) {
  .explore__header {
    flex-direction: column;
  }

  .explore__grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .join__container {
    margin-bottom: 15rem;
  }

  .join__grid {
    width: 100%;
    margin: 0;
    bottom: -20rem;
  }

  .price__grid {
    grid-template-columns: repeat(1, 1fr);
  }

  .review__container {
    flex-direction: column;
    gap: 0;
  }

  .review__footer {
    flex-direction: column;
  }

  .footer__container {
    grid-template-columns: 1fr 150px;
  }

  .footer__bar {
    text-align: center;
  }
}
</style>


<script>
import axois from '@/axois';

export default {
  name: 'login',
  data(){
    return {
        form : {
          email : '',
          password : ''
        }
    }
  },

  methods: {
    login(){
      axois.post('/auth/login', this.form).then(response =>{
        console.log(response);
        if(response.data.success){
          localStorage.setItem('token',response.data.data.token);
          window.location.href = '/staff/dashboard'
        }
      }).catch(error =>{
        if(error.response.status === 401){
            this.$toast.error(error.response.data.message);
        }
      })
    }
  }
}

</script>
  